var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bl-client-task" },
    [
      _c(
        "div",
        {
          staticClass:
            "flex flex-col flex-grow-0 flex-shrink-0 w-3/12 h-full gap-2 px-2 py-2"
        },
        [
          _c("custom-search-bar", {
            staticClass: "flex-shrink-0 w-full h-10",
            attrs: {
              name: "search-task",
              value: _vm.currentQuery,
              placeholder: "Search"
            },
            on: {
              "update:value": function($event) {
                return _vm.onSearch($event)
              }
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "flex items-center flex-shrink-0 w-full h-10 gap-2 px-5 text-sm text-white rounded cursor-pointer bg-primary hover:bg-primary3",
              on: { click: _vm.showModal }
            },
            [
              _c("i", { staticClass: "fas fa-plus" }),
              _vm._v(" "),
              _c("div", { staticClass: "font-medium" }, [_vm._v("Add Task")])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "flex items-center flex-shrink-0 h-5" }, [
            _c("div", { staticClass: "text-sm font-medium" }, [
              _vm._v(
                "\n        Showing All Results - " +
                  _vm._s(_vm.totalTasks) +
                  " Task(s)\n      "
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "pr-2 overflow-auto",
              style: {
                height:
                  "calc(100vh - 4.5rem - 1rem - 2.5rem - 2.5rem - 1.25rem - 1.5rem - 0.5rem)"
              }
            },
            [
              _vm.fetchLoading
                ? _c(
                    "div",
                    {
                      staticClass:
                        "flex items-center justify-center w-full h-full"
                    },
                    [_c("div", { staticClass: "blum-loader" })]
                  )
                : !_vm.tasks.length
                ? _c(
                    "div",
                    {
                      staticClass:
                        "flex items-center justify-center w-full h-full"
                    },
                    [
                      _c("div", { staticClass: "text-placeholder" }, [
                        _vm._v("No Task.")
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "px-2 font-medium cursor-pointer text-primary",
                          on: { click: _vm.showModal }
                        },
                        [_vm._v("\n          Add New\n        ")]
                      )
                    ]
                  )
                : _c(
                    "div",
                    { staticClass: "flex flex-col gap-2" },
                    _vm._l(_vm.tasks, function(task) {
                      return _c(
                        "div",
                        {
                          key: task.id,
                          staticClass:
                            "relative w-full transition-all duration-300 border rounded cursor-pointer hover:bg-hover-state",
                          class: [
                            _vm.selectedTask && task.id === _vm.selectedTask.id
                              ? "border-primary"
                              : "border-transparent"
                          ],
                          on: {
                            click: function($event) {
                              return _vm.showDetail(task)
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex items-start justify-between px-6 py-4 rounded",
                              style: {
                                borderBottom:
                                  "6px solid " + task.curriculum_color
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "flex flex-col gap-1" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "text-xs font-medium" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(task.curriculum_name) +
                                          "\n              "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "text-sm font-medium" },
                                    [_vm._v(_vm._s(task.name))]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "popover",
                                      rawName: "v-popover.left",
                                      value: { name: "remove-task-" + task.id },
                                      expression:
                                        "{ name: `remove-task-${task.id}` }",
                                      modifiers: { left: true }
                                    }
                                  ],
                                  staticClass:
                                    "px-2 text-xs text-right text-gray-600 cursor-pointer"
                                },
                                [_c("i", { staticClass: "fas fa-ellipsis-v" })]
                              ),
                              _vm._v(" "),
                              _c(
                                "popover",
                                {
                                  staticClass: "absolute right-8 top-12",
                                  attrs: {
                                    name: "remove-task-" + task.id,
                                    width: 128,
                                    pointer: false
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "px-2 py-1 cursor-pointer hover:bg-hover-state",
                                      on: {
                                        click: function($event) {
                                          return _vm.removeTask(task)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                Delete\n              "
                                      )
                                    ]
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    }),
                    0
                  )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "flex flex-shrink-0 w-9/12 h-full px-2 py-2" }, [
        _c("div", { staticClass: "w-full px-6 py-6 rounded bg-box" }, [
          _c("div", { staticClass: "h-6 font-medium" }, [_vm._v("Goals")]),
          _vm._v(" "),
          _c(
            "div",
            {
              style: { height: "calc(100vh - 4.5rem - 1rem - 3rem - 1.5rem)" }
            },
            [
              _vm.showLoading
                ? _c("div", { staticClass: "grid h-full place-items-center" }, [
                    _c("div", { staticClass: "blum-loader" })
                  ])
                : !_vm.tasks.length || _vm.selectedTask === null
                ? _c(
                    "div",
                    {
                      staticClass:
                        "flex items-center justify-center w-full h-full"
                    },
                    [
                      !_vm.tasks.length
                        ? _c(
                            "div",
                            { staticClass: "flex items-center gap-2" },
                            [
                              _c("div", { staticClass: "text-placeholder" }, [
                                _vm._v("No Task.")
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "px-2 font-medium cursor-pointer text-primary",
                                  on: { click: _vm.showModal }
                                },
                                [
                                  _vm._v(
                                    "\n              Add Task\n            "
                                  )
                                ]
                              )
                            ]
                          )
                        : _c(
                            "div",
                            { staticClass: "flex items-center gap-2" },
                            [
                              _c("div", { staticClass: "text-placeholder" }, [
                                _vm._v("No Goals.")
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "px-2 font-medium cursor-pointer text-primary",
                                  on: {
                                    click: function($event) {
                                      return _vm.showDetail(_vm.tasks[0])
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              Select Task\n            "
                                  )
                                ]
                              )
                            ]
                          )
                    ]
                  )
                : _c("TaskGoals", {
                    attrs: {
                      selectedTask: _vm.selectedTask,
                      curriculumOptions: _vm.curriculumOptions
                    }
                  })
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "modal",
        {
          staticClass: "overflow-auto",
          attrs: {
            name: "add-task-modal",
            height: "auto",
            minWidth: 800,
            adaptive: true
          }
        },
        [
          _c("div", { staticClass: "px-8 py-8" }, [
            _c(
              "div",
              { staticClass: "flex items-center justify-between mb-8" },
              [
                _c("div", { staticClass: "text-xl font-bold font-logo" }, [
                  _vm._v("New Task")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "px-2 text-right cursor-pointer",
                    on: { click: _vm.hideModal }
                  },
                  [_c("i", { staticClass: "fas fa-times" })]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "form",
              {
                staticClass: "grid gap-24",
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.addTask($event)
                  }
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "grid gap-4" },
                  [
                    _c("BlInputText", {
                      attrs: { input: _vm.nameInput },
                      on: { changed: _vm.inputHandler }
                    }),
                    _vm._v(" "),
                    _c("BlSelectBox", {
                      attrs: {
                        label: "Curriculum",
                        asterisk: "",
                        search: "",
                        placeholder: "Select curriculum",
                        options: _vm.curriculumOptions
                      },
                      on: {
                        change: function($event) {
                          _vm.curriculumIdInput = $event
                        }
                      },
                      model: {
                        value: _vm.curriculumIdInput,
                        callback: function($$v) {
                          _vm.curriculumIdInput = $$v
                        },
                        expression: "curriculumIdInput"
                      }
                    }),
                    _vm._v(" "),
                    _c("BlInputText", {
                      attrs: { input: _vm.descriptionInput },
                      on: { changed: _vm.inputHandler }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass:
                      "px-6 py-2 text-sm font-medium text-white rounded bg-primary hover:bg-primary3",
                    class: { "cursor-wait": _vm.submitLoading },
                    attrs: { type: "submit" }
                  },
                  [_vm._v("\n          Save\n        ")]
                )
              ]
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-22df9507", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22df9507","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/clients/ClientTask.vue
// module id = null
// module chunks = 